import React from "react"
import {Deal} from "@irati/types"
import {isUserDOBRequired} from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth"
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly"
import {OnDealSubmit} from "../../../containers/DealInfo"
import AppOnly from "./AppOnly"
import BirthdayBoxCTA from "./BirthdayBoxCTA"
import StandardCTA from "./StandardCTA"

interface Props {
  id?: string,
  deal: Deal,
  onSubmit: OnDealSubmit
}

const CTA: React.FC<Props> = ({id, deal, onSubmit}) => {
  if (isAppOnly(deal)) {
    return <AppOnly id={id} />
  }

  if (isUserDOBRequired(deal)) {
    return <BirthdayBoxCTA id={id} deal={deal} onSubmit={onSubmit} />
  }

  return <StandardCTA id={id} deal={deal} onSubmit={onSubmit} />
}

export default CTA
